export default __webpack_public_path__ + "static/media/banner1.ff41673d.webp";